import { Layout } from 'antd';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import Header from '../../../components/Molecules/Header/Header';
import CardView from '../../../components/Organisms/CardView/CardView';
import { ReactComponent as Leading } from '../../../res/svg/card-tag.svg';
import { ReactComponent as IdCardOutlined } from '../../../res/svg/card-id.svg';
import { ReactComponent as UserOutlined } from '../../../res/svg/user-outlined.svg';
import { adminItemsMenu } from '../../../utils/utils';
import './AdminIndex.less';
import Navbar from '../../../components/Organisms/Navbar/Navbar';
import { permissionProfileAdmin, userSubMenu } from '../../../utils/functions';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { useEffect } from 'react';

/**
 * @page Admin.tsx
 * @description Main page for the admin.
 * @return { page }
 */
function Admin() {
  //@ts-ignore
  const user = JSON.parse(localStorage.getItem('currentUser'));
  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  const menu = [
    {
      text: 'Administrar Tipos de Tareas',
      color: 'red-4',
      icon: <Leading fontSize={24} />,
      key: 'taskType',
    },
    {
      text: 'Administrar Roles',
      color: 'gold-4',
      icon: <IdCardOutlined />,
      key: 'rolesAdmin',
    },
    {
      text: 'Gestionar Usuarios',
      color: 'terciario-3',
      icon: <UserOutlined />,
      key: 'userAdmin',
    },
  ];
  const accessOnClick = (item: string, navigate: NavigateFunction) => {
    adminItemsMenu(item, navigate);
  };

  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };

  useEffect(() => {
    //solo perfil admin pueden ingresar
    permissionProfileAdmin(navigate);
  }, [])

  return (
    <Layout>
      <Navbar subsection={'admin'} currentScreen={'admin'} showItems={true} itemsCallback={itemsCallback} />
      <Layout className='org-admin__layout'>
        <Header user={user} />
        <div className='org-admin__card__section'>
          {menu.map((content, ix) =>
            <CardView
              key={ix}
              text={content.text}
              color={content.color}
              icon={content.icon}
              cardOnClick={accessOnClick}
            />,
          )}
        </div>
      </Layout>
    </Layout>
  );
}

export default Admin;
